import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { useNavbar } from './hooks/useNavbar';
import { PRIVATE_PATH } from '@/constants';
import { StyledMenu } from './Navbar.styles';

const { Item } = Menu;

export const Navbar = () => {
  const { menuItems, current, onClick } = useNavbar();

  return (
    <StyledMenu onClick={onClick} selectedKeys={[current]} mode="horizontal" className="app-shell-subnav">
      {menuItems.map(({ key, title, path }) => (
        <Item key={key}>
          <Link to={PRIVATE_PATH.MEDIA_PLAN + path}>{title}</Link>
        </Item>
      ))}
    </StyledMenu>
  );
};

export default Navbar;
